import React from 'react';
import { string } from 'prop-types';
import Card from '@mui/material/Card';
import { ActivityBookmarkLoadingWrapper, Url, PreviewTitle, LoadingView, LoadingTextContent } from './ActivityBookmarkLoading.styles';
import { Spinner } from '../../Atoms/Spinner';
export const ActivityBookmarkLoading = _ref => {
  let {
    url,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(ActivityBookmarkLoadingWrapper, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(LoadingView, null, /*#__PURE__*/React.createElement(Spinner, null), /*#__PURE__*/React.createElement(LoadingTextContent, null, /*#__PURE__*/React.createElement(PreviewTitle, null, title), url ? /*#__PURE__*/React.createElement(Url, {
    "data-test-id": "url"
  }, url) : null))));
};
ActivityBookmarkLoading.propTypes = {
  title: string,
  url: string
};
ActivityBookmarkLoading.defaultProps = {
  title: 'Fetching...',
  url: ''
};